import { ErrorComponent, LoadingComponent, useExecutionDataView } from "@gooddata/sdk-ui";
import React, { useContext, useEffect, useMemo, useState } from "react";
import MeasuresContext, { flagServiceMap } from "../../contexts/Measures";
import { colors } from "../../constants";
import { useAppContext } from "../../contexts/AppContext";
import { newArithmeticMeasure } from "@gooddata/sdk-model";
import * as Md from "../../md/full";
import { Dropdown } from "antd";
import { RiUnpinFill } from "react-icons/ri";
import { FiMoreVertical } from "react-icons/fi";
import { useDashboard } from "../../contexts/DashboardProvider";
import UserContext from "../../contexts/User";
import { MonthlyConfiguration, WeeklyConfiguration } from "../Baskets/BasketViz/AggregatedBasketViz";

const BasketLineWidget = ({ id, execDefinition, widgetUid, componentChild, ...props }) => {
    const { selectedKpi } = useContext(MeasuresContext);
    const { getColorByCustId, getCustlabelByCustId } = useAppContext();
    const { defaultUserPref } = useContext(UserContext);
    const [data, setData] = useState({});
    const [trendCategoryTitles, setTrendCategoryTitles] = useState([]);
    const frequencyConfiguration = useMemo(() => (defaultUserPref?.fl_weekly ? WeeklyConfiguration : MonthlyConfiguration), [defaultUserPref]);

    const displayMode = props.displayMode;
    const rolledForwardTrendPoints = props.rolledForwardTrendPoints;
    const { seriesBy: execSeries, slicesBy, filters } = execDefinition;
    const [newSeries, setNewSeries] = useState([...execSeries]);
    const { unPinwWidget } = useDashboard();
    const { result, status } = useExecutionDataView({
        execution: {
            seriesBy: [...newSeries],
            slicesBy: [...slicesBy, frequencyConfiguration.field],
            filters,
        },
    });
    const { flag_services } = props;

    useEffect(() => {
        const dataSerie = result
            ?.data()
            .series()
            .toArray()
            .find((serie) => serie.measureTitle() === newSeries[selectedKpi.index].measure.localIdentifier);
        const slices = result?.data().slices().toArray();
        if (dataSerie && slices) {
            const scrapingDates = slices.reduce((acc, slice) => {
                let mthCode = frequencyConfiguration.formatSliceField(slice.sliceTitles()[2]);
                !acc.includes(mthCode) && acc.push(mthCode);
                return acc;
            }, []);
            scrapingDates.sort();
            let trendColorCopy = colors.slice();
            const serieColors = slices.reduce((acc, slice, index) => {
                let attrValue = displayMode.attributes.reduce((acc, attr, index) => acc + "" + slice.sliceTitles()[index + 1], "");
                if (!(attrValue in acc)) {
                    acc[attrValue] = trendColorCopy.shift();
                }
                // !acc.includes(attrValue) && acc.push(Object.assign());
                return acc;
            }, {});

            const trendData = dataSerie.dataPoints().reduce((acc, dp) => {
                const sliceTitles = dp.sliceDesc.sliceTitles();
                const custValue = sliceTitles[0];
                const serieTitle = sliceTitles[1];
                const scrapeDate = frequencyConfiguration.formatSliceField(sliceTitles[2]);
                const dataPoint = Number(dp.rawValue) === 0 ? null : selectedKpi.index === 24 ? Number((Number(dp.rawValue) * 100).toFixed(2)) : Math.round(Number(dp.rawValue));
                if (custValue in acc) {
                    let serieElem = acc[custValue].find((item) => item.name === serieTitle);
                    if (serieElem) {
                        const mthIndex = scrapingDates.findIndex((item) => item === scrapeDate);
                        serieElem.data[mthIndex] = [scrapeDate, dataPoint];
                    } else {
                        let dataValues = Array(scrapingDates?.length).fill([scrapeDate, null]);
                        const mthIndex = scrapingDates.findIndex((item) => item === scrapeDate);
                        dataValues[mthIndex] = [scrapeDate, dataPoint];
                        acc[custValue].push({
                            name: serieTitle,
                            data: dataValues,
                            color: serieColors[serieTitle],
                        });
                    }
                } else {
                    let dataValues = Array(scrapingDates?.length).fill([scrapeDate, null]);
                    const mthIndex = scrapingDates.findIndex((item) => item === scrapeDate);
                    dataValues[mthIndex] = [scrapeDate, dataPoint];
                    acc[custValue] = [
                        {
                            name: serieTitle,
                            data: dataValues,
                            color: serieColors[serieTitle],
                        },
                    ];
                }
                return acc;
            }, {});

            const TrendDataV = dataSerie.dataPoints().reduce((acc, dp) => {
                const sliceTitles = dp.sliceDesc.sliceTitles();
                const versionStd = sliceTitles[1];
                const custSerieTitle = getCustlabelByCustId(sliceTitles[0]);
                const scrapingDate = frequencyConfiguration.formatSliceField(sliceTitles[2]);
                const dataPoint = Number(dp.rawValue) === 0 ? null : selectedKpi.index === 24 ? Number((Number(dp.rawValue) * 100).toFixed(2)) : Math.round(Number(dp.rawValue));
                if (versionStd in acc) {
                    let serieElem = acc[versionStd].find((item) => item.name === custSerieTitle);
                    if (serieElem) {
                        const mthIndex = scrapingDates.findIndex((item) => item === scrapingDate);
                        serieElem.data[mthIndex] = [scrapingDate, dataPoint];
                    } else {
                        let dataValues = Array(scrapingDates?.length).fill([scrapingDate, null]);
                        const mthIndex = scrapingDates.findIndex((item) => item === scrapingDate);
                        dataValues[mthIndex] = [scrapingDate, dataPoint];
                        acc[versionStd].push({
                            name: custSerieTitle,
                            data: dataValues,
                            color: getColorByCustId(sliceTitles[0]),
                        });
                    }
                } else {
                    let dataValues = Array(scrapingDates?.length).fill([scrapingDate, null]);
                    const mthIndex = scrapingDates.findIndex((item) => item === scrapingDate);
                    dataValues[mthIndex] = [scrapingDate, dataPoint];
                    acc[versionStd] = [
                        {
                            name: custSerieTitle,
                            data: dataValues,
                            color: getColorByCustId(custSerieTitle),
                        },
                    ];
                }
                return acc;
            }, {});

            setTrendCategoryTitles(scrapingDates);
            if (displayMode.key === "player") {
                setData(trendData);
            } else {
                setData(TrendDataV);
            }
        }
    }, [result, newSeries]);

    useEffect(() => {
        if (flag_services) {
            const enabledServices = Object.keys(flag_services)
                .filter((flService) => flService in flagServiceMap && flag_services[flService])
                .map((flService) => flagServiceMap[flService]);
            newSeries.splice(23, 1, newArithmeticMeasure([Md.FinRental.Avg, Md.AdjDeposit.Avg, ...enabledServices], "sum"));
            newSeries.splice(24, 1, newArithmeticMeasure([newArithmeticMeasure([Md.FinRental.Avg, Md.AdjDeposit.Avg, ...enabledServices], "sum"), Md.ListPrice.Avg], "ratio"));
            setNewSeries([...newSeries]);
        }
    }, [componentChild, flag_services]);

    return status === "success" && data[props.custIndex]?.length > 0 ? (
        <>
            {React.createElement(componentChild, {
                data: data[props.custIndex],
                categories: trendCategoryTitles,
                displayMode: displayMode,
                legendStyle: {
                    fontSize: data[props.custIndex]?.length > 8 ? "8px" : "10px",
                    fontWeigth: data[props.custIndex]?.length > 8 ? "400" : "600",
                    color: "#595959",
                    ellipsis: data[props.custIndex]?.length > 6 ? true : false,
                    width: data[props.custIndex]?.length > 6 ? "130px" : "auto",
                },
                custIndex: props.custIndex,
                kpiSettings: flag_services,
                widgetUid,
                scaleUnit: defaultUserPref.fl_weekly ? "datetime" : "default",
                rolledForwardTrendPoints,
                ...props,
            })}
        </>
    ) : status === "loading" ? (
        <div className="min-h-[400px] flex items-center justify-center">
            <LoadingComponent />
        </div>
    ) : (
        <div className="relative">
            <Dropdown
                menu={{
                    items: [
                        {
                            key: "unpin",
                            icon: <RiUnpinFill />,
                            label: "Unpin widget",
                            onClick: () => unPinwWidget(widgetUid),
                        },
                    ],
                }}
                trigger={["click"]}
            >
                <FiMoreVertical className="absolute top-2 right-2 z-40 rounded w-8 h-8 px-1.5 py-1 text-gray-500 cursor-pointer hover:bg-backgroundColor hover:text-indigo-700" />
            </Dropdown>
            <div className="min-h-[400px] flex flex-col items-center justify-center">
                <ErrorComponent />
                <span className="text-sm font-medium text-steel/80 text-center py-2">
                    Seems like there is an issue with the data or the widget <br /> try unpinning and re-pinning it
                </span>
            </div>
        </div>
    );
};

export default BasketLineWidget;
